import React from "react";
import { Link } from "react-router-dom";
import Logo from '../assets/logo.png';

const Home = () => {
    const storedUser = localStorage.getItem("username");
    const storedBranch = localStorage.getItem("branch");
    

   
    
  return (
    <div> 
     <div id="int-container">
            <div>
                <img src={Logo} alt="Logo" className="logo"/>
            </div>
        
           <div>
    <p className="log-detail">
        <span className="label">Username :</span>
        <span className="detail">{storedUser}</span>
    </p>
    <p className="log-detail">
        <span className="label">Branch :</span>
        <span className="detail">{storedBranch}</span>
    </p>
</div>

        </div>
        <div id="home-container">
    <div className="card-style">
   <Link to="/temp1"><div className="card">
	<div className="bottom">
		<h1>Vehicle<br/> Maintenance</h1>
		<p>Track vehicle kilometers, hours, and diesel usage effortlessly. Optimize maintenance with accurate, real-time data!</p>
	</div>
</div>
</Link>

<Link to="../inventory/indentNoteView"> <div className="card-">
	<div className="bottom">
    <h1>Purchase & <br/> Inventory</h1>
		<p>Manage purchases and inventory with precision. Streamline stock tracking for efficient operations.</p>
	</div>
</div>
</Link>


</div>

<div className="card-style">
<Link to="../admin/admin_members_list"><div className="card">
	<div className="bottom">
		<h1>Admin</h1>
		{/* <p>Track vehicle kilometers, hours, and diesel usage effortlessly. Optimize maintenance with accurate, real-time data!</p> */}
	</div>
</div>
</Link>

<Link to="../superAdmin/admin_members_list"> <div className="card-">
	<div className="bottom">
    <h1>Super & <br/> Admin</h1>
		<p>Manage purchases and inventory with precision. Streamline stock tracking for efficient operations.</p>
	</div>
</div>
</Link>


</div>
    </div>

    </div>

    
  );
};

export default Home;
 